<template>
  <div :class="{ 'page-block': pending }">
    <div :class="{ 'page-block__inner': pending }">
      <div>
        <div class="form-wrap u-no-margin-top">
          <div
            class="form-group-wrap__title copyright-main-title"
            style="margin-top: 10px">
            <label
              class="control-label"
              for="title">
              作品タイトル
            </label>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label
                class="control-label"
                for="copyright_application_id">
                著作権申請ID
              </label>
            </div>
            <div class="form-item word-break">
              {{ item.product_disc_track_id }}-{{ item.id }}
            </div>
          </div>
          <!-- TITLE START -->
          <div class="form-group">
            <div class="form-label">
              <label
                class="control-label"
                for="title_ja">
                タイトル名
                <span class="req">＊</span>
              </label>
            </div>
            <div class="form-item word-break">
              {{ item.title_ja }}
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label
                class="control-label"
                for="title_kana">
                タイトル名（カナ表記）
                <span class="req">＊</span>
              </label>
            </div>
            <div class="form-item word-break">
              {{ item.title_kana }}
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label
                class="control-label"
                for="title_ja">
                タイトル名（アルファベット表記）
                <span class="req">＊</span>
              </label>
            </div>
            <div class="form-item word-break">
              {{ item.title_en }}
            </div>
          </div>
          <!-- TITLE END -->
          <!--MAIN ARTIST START-->
          <template>
            <div class="form-group-wrap pb-0">
              <div class="form-group-wrap__title">
                <label class="control-label">
                  メインアーティスト
                  <span class="req">＊</span>
                </label>
              </div>
              <div
                v-for="(mArtist, index) in item.artists.main_artists"
                :key="index">
                <copyright-artist-confirm :artist="mArtist" />
              </div>
            </div>
          </template>
          <!--MAIN ARTIST END-->
          <!--FEATURING ARTIST START-->
          <template>
            <div class="form-group-wrap pb-0">
              <div class="form-group-wrap__title">
                Featuringアーティスト
                <span
                  v-if="isEmptyFeaturingArtists"
                  class="no-featuring-artist-text">
                  未設定
                </span>
              </div>
              <template v-if="hasFeaturingArtists">
                <div
                  v-for="(fArtist, index) in item.artists.featuring_artists"
                  :key="index">
                  <copyright-artist-confirm :artist="fArtist" />
                </div>
              </template>
            </div>
          </template>
          <!--FEATURING ARTIST END-->
          <!-- INSTRUMENTAL START -->
          <div class="form-group">
            <div class="form-label">
              <label class="control-label">インストゥルメンタル
                <span class="req">＊</span>
              </label>
            </div>
            <div class="form-item word-break">
              {{ item.is_instrumental ? '有' : '無' }}
            </div>
          </div>
          <!-- INSTRUMENTAL END -->
          <div class="form-group">
            <div class="form-label">
              <label
                class="control-label"
                for="play_time_min">演奏時間
              </label>
              <span class="req">＊</span>
            </div>
            <div class="form-item-inline">
              <div class="form-item">
                {{ `${item.play_time_min}分 ${item.play_time_sec}秒` }}
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label class="control-label">
                発売日
                <span class="req">＊</span>
              </label>
            </div>
            <div
              class="form-item word-break">
              {{ item.released_date }}
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label
                class="control-label"
                for="label_name">
                レーベル名
              </label>
            </div>
            <div class="form-item word-break">
              {{ item.label_name }}
            </div>
          </div>
          <!--AUTHOR START-->
          <div class="form-group-wrap border-none">
            <div class="form-group-wrap__title">
              <label class="control-label">
                著作者
                <span class="req">＊</span>
              </label>
            </div>
            <div
              v-for="(author, index) in item.authors"
              :key="index">
              <div>
                <div class="form-wrap author-form-wrap--with-border">
                  <div class="form-group">
                    <div class="form-label">
                      <label class="control-label">この著作者はアカウント管理者本人ですか？</label>
                    </div>
                    <div
                      class="form-item word-break">
                      {{ author.author_meta.is_owner ? 'はい' : 'いいえ' }}
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label">
                      <label class="control-label">著作者区分</label>
                    </div>
                    <div
                      class="form-item word-break">
                      {{ mapRoles(author.pivot.author_roles) }}
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label">
                      <label class="control-label">グループ</label>
                    </div>
                    <div
                      class="form-item word-break">
                      {{ author.author_meta.is_group ? '有' : '無' }}
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label">
                      <label
                        class="control-label"
                        :for="'artist_name_domestic' + index">著作者公表名
                        <span class="req">＊</span>
                      </label>
                    </div>
                    <div
                      class="form-item word-break">
                      {{ author.name_ja }}
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label">
                      <label
                        class="control-label"
                        :for="'artist_name_kana' + index">著作者公表名（カナ表記）
                        <span class="req">＊</span>
                      </label>
                    </div>
                    <div class="form-item word-break">
                      {{ author.name_kana }}
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="form-label form-label--top">
                      <label
                        class="control-label"
                        :for="'artist_name_overseas' + index">著作者公表名（アルファベット表記）
                        <span class="req">＊</span>
                      </label>
                    </div>
                    <div class="form-item word-break">
                      {{ author.name_en }}
                    </div>
                  </div>
                  <div
                    v-if="!author.author_meta.is_owner"
                    class="form-group">
                    <div class="form-label form-label--top">
                      <label
                        class="control-label"
                        :for="'author_email' + index">著作者メールアドレス
                        <span class="req">＊</span>
                      </label>
                    </div>
                    <div class="form-item word-break">
                      {{ author.author_meta.email }}
                    </div>
                  </div>
                  <div v-if="author.author_meta.group_meta.length === 0">
                    <div class="form-group">
                      <div class="form-label form-label--top">
                        <label
                          class="control-label"
                          :for="'artist_name_ja_name' + index">著作者実名
                          <span class="req">＊</span>
                        </label>
                      </div>
                      <div class="form-item word-break">
                        {{ author.author_meta.personal_meta.real_name.ja.name }}
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="form-label form-label--top">
                        <label
                          class="control-label"
                          :for="'artist_name_en_name' + index">著作者実名（アルファベット表記）
                          <span class="req">＊</span>
                        </label>
                      </div>
                      <div class="form-item word-break">
                        {{ author.author_meta.personal_meta.real_name.en.name }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="author.author_meta.is_group"
                    class="members b-1">
                    <div
                      v-for="(gItem, mIndex) in author.author_meta.group_meta"
                      :key="mIndex">
                      <div class="form-group">
                        <div class="form-label form-label--top">
                          <label
                            class="control-label"
                            :for="'member_ja_name'+ mIndex">メンバー{{ mIndex + 1 }}実名
                            <span class="req">＊</span>
                          </label>
                        </div>
                        <div class="form-item word-break">
                          {{ gItem.real_name.ja.name }}
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="form-label form-label--top">
                          <label
                            class="control-label"
                            :for="'member_en_name'+ mIndex">メンバー{{ mIndex + 1 }}実名
                            <span class="req">＊</span>
                          </label>
                        </div>
                        <div class="form-item word-break">
                          {{ gItem.real_name.en.name }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="author.author_meta.group_meta.length === 0"
                    class="form-group">
                    <div class="form-label">
                      <label
                        class="control-label">
                        JASRACメンバーですか？<br>
                        (海外著作権団体のメンバーですか？)
                      </label>
                    </div>
                    <div class="form-item word-break">
                      {{ author.author_meta.personal_meta.is_jasrac_member ? 'はい' : 'いいえ' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--AUTHOR END-->
        </div>
        <div
          class="c-btn-wrap">
          <button
            class="c-btn c-btn--back c-btn--back-left"
            @click.prevent="onReturnClicked">
            {{ pending ? '一覧へ戻る' : '著作権管理スプリットトップへ' }}
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CopyrightArtistConfirm from '../Common/ArtistConfirm'
import {
  CMAP_COPYRIGHT_STATUS_IN_PROGRESS,
  CMAP_COPYRIGHT_STATUS_IN_REVIEW,
  CMAP_COPYRIGHT_STATUS_PROCESSING,
} from '../../../../consts/status'

export default {
  name: 'SplitConfirm',
  components: {
    CopyrightArtistConfirm,
  },
  props: {
    pending: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      item: {
        title_ja: '',
        title_kana: '',
        title_en: '',
        artists: {
          main_artists: [],
          featuring_artists: [],
        },
        authors: [],
        is_instrumental: false,
        play_time_min: 0,
        play_time_sec: 0,
        released_date: '',
        label_name: '',
        product_disc_track_id: '',
        status: CMAP_COPYRIGHT_STATUS_IN_PROGRESS,
      },
      readOnly: false,
      confirmed: false,
    }
  },
  computed: {
    isEmptyFeaturingArtists() {
      return this.item.artists.featuring_artists && this.item.artists.featuring_artists.length === 0
    },
    hasFeaturingArtists() {
      return this.item.artists.featuring_artists && this.item.artists.featuring_artists.length > 0
    },
    isProgressStatus() {
      return this.item.status === CMAP_COPYRIGHT_STATUS_IN_PROGRESS
    },
  },
  async mounted() {
    const copyrightSplit = JSON.parse(window.sessionStorage.getItem('copyright-split'))
    await this.getCopyrights(copyrightSplit.copyrightId)
    if (
      this.item.status === CMAP_COPYRIGHT_STATUS_IN_REVIEW
      || this.item.status === CMAP_COPYRIGHT_STATUS_PROCESSING
    ) {
      this.readOnly = true
    }
  },
  methods: {
    async getCopyrights(id) {
      const { data } = await window.axios.get('/api/client/copyrights', {
        params: {
          id,
        },
      })
      const copyrights = data.data[0]
      const [playTimeMin, playTimeSec] = copyrights.play_time.split(':')
      copyrights.play_time_min = playTimeMin
      copyrights.play_time_sec = playTimeSec
      copyrights.is_instrumental = copyrights.is_instrumental === 1
      this.item = { ...this.item, ...copyrights }
    },
    onReturnClicked() {
      this.$router.push({ name: this.pending ? 'copyright-index' : 'copyright-splits' })
    },
    mapRoles(inputArray) {
      const checkedRoles = inputArray
        .filter(role => role.checked)
        .map(role => role.label)

      return checkedRoles.join(', ')
    },
  },
}
</script>
<style scoped>
.border-none {
  border: 0
}
.pb-0 {
  padding-bottom: 0 !important;
}
.word-break {
  word-break: break-all;
}
.form-group-wrap {
  border-bottom: none;
}
.author-form-wrap--with-border {
  padding: 30px;
  border: 2px solid #dadada;
  margin: 30px 0 0 0 !important;
}

.b-1 {
  border: 1px solid #dadada !important;
  border-radius: 5px;
  padding: 0 10px 10px 20px;
  margin-top: 30px;
}
.word-break {
  word-break: break-all;
}

.form-group {
  padding: 15px 0;
}
</style>
